export enum FilterTypeEnum {
  INPUT_FILTER = 'input',
  DROPDOWN_FILTER = 'dropdown'
}
